import React, { Component } from 'react';
import Panel from '../../../../../../components/angle/Panel/index';
import { Tabs, Tab } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import ClassForm from '../../../../components/ClassForm';
import FilingListGrid from '../../../../components/FilingListGrid';
import SalesPanel from '../../../../components/SalesPanel';
import SalesListGrid from '../../../../components/SalesListGrid';
import AdvancedSalesListGrid from '../../../../components/AdvancedSalesListGrid';
import HistoryGrid from '../../components/HistoryGrid';

import { fetchStates } from '../../../../../../services/redux/commonData/actions';
import {
    updateClassHistoryItemSelected,
    handleViewClassVisibility,
    handleEditClassVisibility,
    fetchClassSales,
    fetchClassAdminSales,
    fetchClassFilings
} from '../../../../../../services/redux/employee/classes/actions';
import { fetchTrustData } from '../../../../../../services/redux/employee/trust/actions';
import { fetchPortfolioById } from '../../../../../../services/redux/employee/portfolio/actions';
import {
    fetchFilingById,
    updateFilingInfoData,
    fetchClientData,
    fetchStateData
} from '../../../../../../services/redux/employee/filing/actions';

class ViewClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1
        };
    }

    componentDidMount() {
        let { fetchStates } = this.props;
        fetchStates();
    }
    onEditClick = () => {
        let {
            handleViewClassVisibility,
            handleEditClassVisibility
        } = this.props;
        handleViewClassVisibility(false);
        handleEditClassVisibility(true);
    };
    onBackClick = () => {
        let { handleViewClassVisibility, location, history } = this.props;
        if (location.from && location.from !== '/client-details') {
            history.push({
                pathname: location.from,
                from: '/client-details'
            });
        } else {
            handleViewClassVisibility(false);
        }
    };

    onViewSalesClick = (startDate, endDate, state = '') => {
        let { classes, fetchClassSales } = this.props;
        fetchClassSales({
            classId: classes.viewClass.classId,
            startDate,
            endDate,
            state
        });
    };

    onViewAdvancedSalesClick = (startDate, endDate, state = '') => {
        let { classes, fetchClassAdminSales } = this.props;
        fetchClassAdminSales({
            classId: classes.viewClass.classId,
            startDate,
            endDate,
            state
        });
    };

    onChangeTab = key => {
        this.setState({ activeTab: key });
    };

    reviewPendingFiling = data => {
        let {
            history,
            classes,
            fetchFilingById,
            fetchClientData,
            fetchStateData,
            fetchTrustData,
            fetchPortfolioById,
            updateFilingInfoData
        } = this.props;

        fetchFilingById(data.filingId).then(response => {
            if (response) {
                fetchClientData(response.clientId);
                fetchStateData(response.stateId);
            }
        });

        let filingInfoData = data;
        fetchPortfolioById(classes.editClass.portfolioId).then(resp1 => {
            if (resp1 && resp1.name) {
                filingInfoData = {
                    ...filingInfoData,
                    portfolioName: resp1.name
                };
                fetchTrustData(resp1.trustId).then(resp2 => {
                    if (resp2 && resp2.name) {
                        filingInfoData = {
                            ...filingInfoData,
                            trustName: resp2.name
                        };
                    }
                    updateFilingInfoData({
                        ...filingInfoData,
                        className: classes.editClass.name
                    });
                });
            }
        });
        history.push({ pathname: '/filing-details', from: '/client-details' });
    };

    render() {
        let {
            classes,
            commonData,
            roleName,
            updateClassHistoryItemSelected
        } = this.props;
        let { activeTab } = this.state;
        let backButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onBackClick}
            >
                Back
            </button>
        );
        let editButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onEditClick}
            >
                Edit
            </button>
        );

        return (
            <div className="panel">
                <Tabs
                    id="tabID"
                    onSelect={this.onChangeTab}
                    activeKey={this.state.activeTab}
                    mountOnEnter={true}
                    unmountOnExit={true}
                >
                    <Tab eventKey={1} title="View Class">
                        <Panel>
                            <div className="col-lg-6 col-md-8 col-sm-12">
                                <ClassForm
                                    classData={classes.editClass}
                                    parentPortfolios={classes.parentPortfolios}
                                    isEditable={false}
                                />
                            </div>
                        </Panel>
                    </Tab>
                    <Tab eventKey={2} title="Filings">
                        <FilingListGrid
                            dataList={classes.filings}
                            handleReviewButtonClick={this.reviewPendingFiling}
                        />
                    </Tab>
                    <Tab eventKey={3} title="Sales">
                        <SalesPanel
                            onViewClick={this.onViewSalesClick}
                            stateList={commonData.states}
                        />
                        <SalesListGrid dataList={classes.sales} />
                    </Tab>
                    {(roleName === 'Administrator' ||
                        roleName === 'Superuser') && (
                        <Tab eventKey={4} title="Advanced Sales">
                            <SalesPanel
                                onViewClick={this.onViewAdvancedSalesClick}
                                stateList={commonData.states}
                            />
                            <AdvancedSalesListGrid
                                dataList={classes.adminSales}
                            />
                        </Tab>
                    )}
                    <Tab eventKey={5} title="Change Log">
                        <HistoryGrid
                            dataList={classes.history}
                            updateSelected={updateClassHistoryItemSelected}
                        />
                        {classes.selectedHistoryItem &&
                            classes.selectedHistoryItem.classId && (
                                <Panel
                                    showHeader
                                    header="History Item Details"
                                    panelStyle="panel-default m0"
                                >
                                    <div className="col-lg-6 col-md-8 col-sm-12">
                                        <ClassForm
                                            classData={
                                                classes.selectedHistoryItem
                                            }
                                            parentPortfolios={
                                                classes.parentPortfolios
                                            }
                                            isEditable={false}
                                        />
                                    </div>
                                </Panel>
                            )}
                    </Tab>
                    <br />
                    {activeTab === 1 && editButton}
                    {backButton}
                </Tabs>
                {classes.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    classes: state.employee.classes,
    commonData: state.commonData,
    roleName: state.authentication.user
        ? state.authentication.user.roleName
        : ''
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchStates,
            updateClassHistoryItemSelected,
            handleViewClassVisibility,
            handleEditClassVisibility,
            fetchClassSales,
            fetchClassAdminSales,
            fetchClassFilings,
            fetchFilingById,
            updateFilingInfoData,
            fetchClientData,
            fetchStateData,
            fetchPortfolioById,
            fetchTrustData
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ViewClass));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientDetails/screens/ViewClass/index.js